import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import GenericButton from './GenericButton';
import { shortLabelText } from '../../util/CrosstabUtils';


const renderLabel = (labelType, label) => {
  if (!labelType) {
    label = label.length < 25 ? label : shortLabelText(label);
  }
  return label;
};

const renderText = (toggleCheckValue, selectedGridData, selectedGrid, index) => {
  let gridTitle = '';
  const isLabelUpdatedFlag = selectedGrid.isLabelUpdated[index];
  if (selectedGridData && selectedGridData.objectsAdded) {
    const objectsAdded = selectedGridData.objectsAdded;
    if (objectsAdded.length > 0 && objectsAdded.length === 1) {
      if (isLabelUpdatedFlag) {
        gridTitle = `${selectedGrid.selectedNames[index]} ${String.fromCharCode(185)}`;
      } else {
        gridTitle = `${objectsAdded[0].breadcrumbs}`;
      }
    } else {
      gridTitle = '';
      objectsAdded.forEach(item => {
        let textValue = '';
        if (item.breadcrumbs) {
          if (isLabelUpdatedFlag) {
            gridTitle = `${selectedGrid.selectedNames[index]} ${String.fromCharCode(185)}`;
            textValue = '';
          } else {
            textValue = `${item.breadcrumbs}`;
          }
        } else if (!selectedGrid.isLabelUpdated[index] && item.objectType === 'operator') {
          textValue = `${textValue} ${item.shortText} `;
        }
        gridTitle += textValue;
      });
    }
    gridTitle = renderLabel(toggleCheckValue, gridTitle);
  } else if (selectedGrid.selectedNames && selectedGrid.selectedNames[index]) {
    gridTitle = `${selectedGrid.selectedNames[index]}`;
  }
  return gridTitle.toUpperCase();
};

const renderData = (gridTitle, selectedGrid, toggleCheckValue) => {
  return (
    <div>
      <h4>
        <b>{`${gridTitle} [${selectedGrid.selectedKeywords.length}]`}:</b>
      </h4>
      {selectedGrid.dataSmartSearch.map((data, index) => (
        <div key={uuid()}>{renderText(toggleCheckValue, data, selectedGrid, index)}</div>
      ))}
    </div>
    );
};

const UserStateModal = ({
  discardLastCrosstab,
  openLastCrosstab,
  lastCrosstabData,
  saveLastCrosstab,
}) => {
  return (
    <div>
      <div className="row">
        <div className="large-10 columns">
          <h4>Would you like to open the last crosstab you were working on?</h4>
        </div>
      </div>
      <div className="row">
        <h4>
          <b className="padding-20">{`Study Name: ${
            lastCrosstabData.studyDescription
          }`}</b>
        </h4>
      </div>
      <div className="row" />
      <div className="row invalid-grid-data">
        {renderData('Columns', lastCrosstabData.columnsGrid, lastCrosstabData.toggleCheckValue ? lastCrosstabData.toggleCheckValue.column : undefined)}
        {renderData('Rows', lastCrosstabData.rowsGrid, lastCrosstabData.toggleCheckValue ? lastCrosstabData.toggleCheckValue.row : undefined)}
        {renderData('Bases', lastCrosstabData.basesGrid, true)}
      </div>
      <div className="modal-footer">
        <GenericButton
          name="Save Crosstab"
          btnStyle="button btn-cncl margin-left-10 float-left margin-right-10"
          onBtnClick={saveLastCrosstab}
        />
        <GenericButton
          name="Open Crosstab"
          btnStyle="button btn-cncl float-right margin-right-10"
          onBtnClick={openLastCrosstab}
        />
        <GenericButton
          name="Discard Crosstab"
          btnStyle="button btn-cncl margin-left-10 float-right margin-right-10"
          onBtnClick={discardLastCrosstab}
        />
      </div>
    </div>
  );
};

UserStateModal.propTypes = {
  openLastCrosstab: PropTypes.func,
  discardLastCrosstab: PropTypes.func,
  saveLastCrosstab: PropTypes.func,
  lastCrosstabData: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

export default UserStateModal;
